<template>
  <div class="ContactUs">
    <div class="ContactUs_title">
      <el-divider>
        <div class="ContactUs_title_name">联系我们</div>
        <div class="ContactUs_title_text">Contact Us</div>
      </el-divider>
    </div>
    <div class="ContactUs_content">
      <div class="ContactUs_content_text">
        <div
          class="ContactUs_content_text_community text-align"
          v-for="item in contactList"
          :key="item.id"
        >
          <div
            class="ContactUs_content_text_community_name text-align"
            v-if="item.title"
          >
            {{ item.title }}
          </div>
          <div
            class="ContactUs_content_text_community_address text-align"
            v-if="item.address"
          >
            地址：{{ item.address }}
          </div>
          <div
            class="ContactUs_content_text_community_mobilePhone text-align"
            v-if="item.cellPhone"
          >
            手机：{{ item.cellPhone }}
          </div>
          <div
            class="ContactUs_content_text_community_phone text-align"
            v-if="item.phone"
          >
            电话：{{ item.phone }}
          </div>
          <div
            class="ContactUs_content_text_community_fax text-align"
            v-if="item.fex"
          >
            传真：{{ item.fex }}
          </div>
          <div
            class="ContactUs_content_text_community_text text-align"
            v-if="item.text"
          >
            {{ item.text }}
          </div>
          <div
            class="ContactUs_content_text_community_email text-align"
            v-if="item.email"
          >
            邮箱：{{ item.email }}
          </div>
          <div
            class="ContactUs_content_text_community_email text-align"
            v-if="item.content"
          >
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>
    <div class="ContactUs_foot">
      <div class="mapClass">
        <el-amap
          vid="mapId"
          :center="center"
          :amap-manager="amapManager"
          :zoom="zoom"
          :events="events"
          class="amap-demo"
        ></el-amap>
      </div>
      <div class="ContactUs_foot_img">
        <img src="../assets/qingye/56.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import { lazyAMapApiLoaderInstance, AMapManager } from "vue-amap";
import { getContactInfoApi } from "@/api/index";

let amapManager = new AMapManager();
export default {
  data() {
    const _this = this;
    return {
      map: null,
      amapManager,
      zoom: 18,
      center: [118.182084, 24.489961],
      events: {
        init() {
          lazyAMapApiLoaderInstance.load().then(() => {
            _this.initMap();
          });
        },
      },
      isShow: false,
      contactList: [],
    };
  },
  mounted() {
    // 地图初始化
    // this.mapInit()
    this.getContactInfo();
  },
  methods: {
    //获取我的信息
    getContactInfo() {
      getContactInfoApi().then((res) => {
        console.log(res);
        this.contactList = res.data;
      });
    },
    // 初始化地图
    initMap() {
      // 创建一个 Icon
      var startIcon = new AMap.Icon({
        // 图标尺寸
        size: new AMap.Size(25, 34),
        // 图标的取图地址
        // image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
        image:
          "data:image/png;base64,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",
        // 图标所用图片大小
        imageSize: new AMap.Size(25, 38),
        // 图标取图偏移量
        // imageOffset: new AMap.Pixel(-9, -3)
      });

      // 将 icon 传入 marker
      var startMarker = new AMap.Marker({
        position: new AMap.LngLat(116.35, 39.89),
        icon: startIcon,
        offset: new AMap.Pixel(-13, -30),
      });

      this.map = amapManager.getMap();
      let marker = new AMap.Marker({
        position: [118.182084, 24.489961],
        icon: startIcon,
      });
      // const geolocation = new AMap.Geolocation({
      //   enableHighAccuracy: true,//是否使用高精度定位，默认:true
      //   timeout: 10000,          //超过10秒后停止定位，默认：5s
      //   position: 'RB',    //定位按钮的停靠位置
      //   buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
      //   zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点
      //
      // });
      // this.map.addControl(geolocation);
      // geolocation.getCurrentPosition(function(status,result){
      //   if(status == 'complete'){
      //     // onComplete(result)
      //   }else{
      //     // onError(result)
      //   }
      // });
      marker.setMap(this.map);
    },

    //高德地图
    //打开地图
    // openMap() {
    //   this.dialogVisible = true
    //   this.$nextTick(() => {
    //     this.init()
    //   });
    // },
    //

    //高德地图
    // init: function () {
    //   let map = new AMap.Map('mapId', {
    //     center: [118.317359, 24.602571],
    //     resizeEnable: true,
    //     zoom: 18,
    //   })
    //   AMap.plugin(['AMap.ToolBar', 'AMap.Scale'], function () {
    //     map.addControl(new AMap.ToolBar())
    //     map.addControl(new AMap.Scale())
    //   })
    // },
    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style scoped>
.ContactUs {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.mapClass {
  /*height: 333px;*/
  /*width: 773px;*/
  height: 60%;
  width: 40%;
  z-index: 99;
  position: absolute;
  bottom: 12%;
  left: 30%;
  box-shadow: 2px 2px 3px 1px #8888;
}

.flex {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.ContactUs_title {
  /*font-size: 28px;*/
  /*font-weight: 600;*/

  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-bottom: 50px;
  /*padding-bottom: 60px;*/
  /*width: 1025px;*/
  width: 1200px;
}

.ContactUs_title_name {
  font-weight: 400;
  text-align: center;
  font-size: 28px;
}

.ContactUs_title_text {
  font-size: 14px;
  text-align: center;
}

.ContactUs_content {
  /*margin-bottom: 70px;*/
  display: flex;
  justify-content: center;
  align-items: center;
  width: 1200px;
  height: 400px;
  /*background-color: #F4F7FC;*/
}

.ContactUs_content_text {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 750px;
}

.ContactUs_content_text_community {
  margin-bottom: 50px;
}

.ContactUs_content_text_community_name {
  padding-bottom: 10px;
  font-weight: 400;
  text-align: center;
  color: #2968bd;
  font-size: 18px;
}

.text-align {
  text-align: center;
}

.ContactUs_foot {
  position: relative;
}

.ContactUs_foot_img {
  height: 100%;
}

.ContactUs_foot img {
  /*min-width: 1200px;*/
  width: 100%;
  z-index: 1;
  height: 100%;
}

.active {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/ContactUs.vue